module.exports = __webpack_public_path__ + "static/media/8.05791612.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/thumbs/8.jpg
// module id = 154
// module chunks = 0